import WriterSideBar from '@Components/Cards/WorkDetailCards/OriginalPublisherCards/OriginalPublisherCardAddWriters/WriterSideBar/index'
import { PublisherSideBarState } from '@App/enum/publisher-side-bar-state'
import EditSimpleOriginalPublisher from '@Components/WorkRegistrationSubs/EditSimpleOriginalPublisher/index'
import AddAdministratorPublisher from '@Components/WorkRegistrationSubs/AddAdministratorPublisher/index'
import AddOriginalPublisher from '@Components/WorkRegistrationSubs/AddOriginalPublisher/index'
import type { OriginalPublisherModel } from '@Entities/work/original-publisher-model'

interface PublisherSidebarContentProps {
    sidebarState: PublisherSideBarState
    editingOP: OriginalPublisherModel | undefined
}

const PublisherSidebarContent = ({ sidebarState, editingOP }: PublisherSidebarContentProps) => {
    switch (sidebarState) {
        case PublisherSideBarState.addOP:
            return <AddOriginalPublisher isRHRestricted />
        case PublisherSideBarState.addAP:
            return <AddAdministratorPublisher isRHRestricted />
        case PublisherSideBarState.editOP:
            return <EditSimpleOriginalPublisher />
        case PublisherSideBarState.addWriterOp:
            return editingOP ? <WriterSideBar data={editingOP} /> : null
        case PublisherSideBarState.empty:
            return null
    }
}

export default PublisherSidebarContent
